
    // THIS FILE IS AUTO-GENERATED via 'yarn build-trans' !!

    export default {
        locale: 'cs_CZ',
        messages: {
			"graphical_template": "Grafická šablona",
			"fill": "Výplň",
			"none": "Žádný",
			"none_compression": "Žádná",
			"shape_color": "Barva výplně",
			"shape_position": "Umístění",
			"shape_size": "Rozměry",
			"triangle": "Trojúhelník",
			"square": "Čtverec",
			"square_format": "Čtvercový",
			"wide": "Na šírku",
			"width": "Šířka",
			"stroke_width": "Šířka okraje",
			"stroke_color": "Barva okraje",
			"text_stroke_width": "Šířka obrysu textu",
			"text_stroke_color": "Barva obrysu textu",
			"frame_image": "Orámovat obrázek",
			"color": "Barva",
			"side": "Strana",
			"text": "Text",
			"text_color": "Barva textu",
			"text_fontsize": "Velikost textu",
			"text_font": "Font",
			"triangle_orientation": "Orientace trojúhelníku",
			"search": "Hledat",
			"up": "Nahoře",
			"down": "Dole",
			"show_frame": "Zobrazit rám",
			"dashed": "Čárkovaný",
			"frame_color": "Barva rámečku",
			"frame_width": "Šířka rámečku",
			"frame_width_placeholder": "Šířka rámečku v pixelech",
			"show_stripe": "Zobrazit pruh",
			"stripe_color": "Barva pruhu",
			"stripe_position": "Umístění pruhu",
			"horizontal": "Vodorovný pruh",
			"vertical": "Svislý pruh",
			"stripe_text_placeholder": "Text v pruhu",
			"shape_text_placeholder": "Text v tvaru",
			"text_size_placeholder": "velikost textu",
			"text_font_placeholder": "font",
			"nav_queries": "Produkty",
			"nav_size": "Formát",
			"nav_frame": "Rám",
			"nav_filter": "Filtr",
			"nav_stripe": "Pruh",
			"nav_shape": "Vrstva",
			"nav_image": "Obrázek",
			"nav_save": "Uložit",
			"nav_shapes": "Vrstvy",
			"upscale_image": "Vylepšit rozlišení",
			"template_type_null": "Grafická šablona",
			"template_type_1": "Vylepšení rozlišení",
			"template_type_2": "Odstranit pozadí",
			"template_type_3": "Odstranění vodoznaků",
			"template_type_4": "Outpainting",
			"template_type_5": "Animovaný GIF",
			"template_type_6": "Inpainting",
			"template_type_10": "Obrázek s odstraněným vodoznakem",
			"template_type_11": "Upravený obrázek s odstraněným pozadím",
			"template_type_1_started": "Probíhá vylepšování obrázku",
			"template_type_2_started": "Probíhá odstraňování pozadí",
			"template_type_3_started": "Probíhá odstraňování vodoznaku",
			"template_type_4_started": "Probíhá outpainting",
			"template_type_6_started": "Probíhá inpainting",
			"template_type_1_done": "Obrázek vylepšen",
			"template_type_2_done": "Pozadí obrázku odstraněno",
			"template_type_3_done": "Vodoznak odstraněn",
			"template_type_4_done": "Outpainting hotov",
			"template_type_6_done": "Inpainting hotov",
			"outpainting_error": "Chyba outpaintingu",
			"outpaint_over": "Outpaintovat přes celé plátno",
			"upscale_previews_all_done": "Náhledy byly vygenerovány. Pro hromadné vylepšení rozlišení vyberte v pravém panelu produktový výběr, na který chcete vylepšení aplikovat. Nezapomeňte šablonu pojmenovat a uložit.",
			"min_detection_accuracy": "minimální přesnost detekce",
			"min_detection_accuracy_info": "bude-li přesnost detekce nižší, ponechá se původní obrázek s vodoznakem",
			"get_previews": "Vygenerovat náhledy",
			"select_images_for_upscale_previews": "Vyberte obrázky, ze kterých si přejete vytvořit náhledy vylepšení rozlišení.",
			"creating_upscale_previews": "Generují se náhledy obrázků. Tato operace je časově náročná, chvíli to potrvá.",
			"sending_images_for_upscale_previews": "Odesílám obrázky",
			"original_image": "Původní obrázek",
			"other_images": "Jiné obrázky",
			"bgremoved_image": "Obrázek s odstraněným pozadím",
			"bgremoved_edited_image": "Upravený obrázek s odstraněným pozadím",
			"wmremoved_image": "Obrázek s odstraněným vodoznakem",
			"upscaled_image": "Vylepšený obrázek",
			"no_images_for_upscale": "Ve vašem feedu jsme nenašli žádné obrázky s rozměry do 600 x 600 pixelů. Vylepšení rozlíšení není nutné.",
			"upscale_template": "Vylepšení rozlišení obrázků",
			"upscale_how_does_it_work": "<h3>Jak to funguje</h3><p>....</p>",
			"upscale_method_preview": "Ukázky vylepšení rozlišení",
			"image_is_upscaled": "Obrázek s vylepšeným rozlišením",
			"show_larger_preview": "Zobrazit větší náhled",
			"upscale_loading_products": "Analyzujeme rozměry obrázků ve vašem feedu. Vylepšení rozlišení má smysl pouze u obrázků s rozměry do 600 x 600 pixelů.",
			"upscale_clear_interval": "Zrušit a vybrat jiné obrázky",
			"clear_selection": "Zrušit výběr",
			"selected_count": "Vybráno",
			"cancel": "Zrušit",
			"position": "Pozice",
			"opacity": "Průhlednost",
			"apply_on_queries": "Aplikovat na produkty",
			"template_name": "Název šablony",
			"template_type": "Typ",
			"save_template": "Uložit šablonu",
			"show_shape": "Zobrazit vrstvu",
			"stroke_opacity": "Průhlednost okraje",
			"priority": "Priorita",
			"template_list": "Seznam šablon",
			"products": "Produkty",
			"images": "Obrázky",
			"count_images": "počet obrázků",
			"validations": "Validace obrázků",
			"new_template": "Nová šablona",
			"new_upscale_template": "Vylepšení rozlišení obrázků",
			"new_bgremove_template": "Odstranění pozadí",
			"new_wmremove_template": "Odstrannění vodoznaku",
			"template_gallery": "Galerie šablon",
			"blank_template": "Prázdná šablona",
			"background_color": "Barva pozadí",
			"text_background_color": "Barva pozadí",
			"background_width": "Šířka",
			"background_height": "Výška",
			"background_type": "Typ pozadí",
			"background_type_none": "Žádné",
			"background_type_circle": "Kolečko",
			"background_type_rectangle": "Obdélník",
			"background_type_rectangle-each-line": "Obdélník na každý řádek",
			"background_type_ellipse": "Elipsa",
			"background_type_image": "Obrázek",
			"random_product": "Náhodný produkt",
			"stroke": "Okraj",
			"full": "Plný",
			"no_templates": "Zatím nemáte žádné šablony. Vytvořte první!",
			"no_alternative_templates": "Zatím nemáte žádné alternativní šablony",
			"all_products": "Všechny produkty",
			"back": "Zpět",
			"back_to_template_list": "Zpět na seznam šablon",
			"due_date": "Termín",
			"created_at": "Vytvořeno",
			"save": "Uložit",
			"save_and_exit": "Uložit a odejít",
			"save_and_apply": "Uložit a použít",
			"save_as_new_template": "Uložit jako novou šablonu",
			"apply": "Aplikovat",
			"saving": "Ukládá se",
			"no_shape_selected": "Nebyla vybrána žádná vrstva.",
			"user": "Uživatel",
			"delete": "Smazat",
			"insert": "Vložit",
			"preview": "Náhled",
			"pause": "Pozastavit",
			"start": "Spustit",
			"action": "Akce",
			"edit": "Upravit",
			"next": "Následující",
			"previous": "Předchozí",
			"project": "Export",
			"eshop": "E-shop",
			"agency": "Agentura",
			"freelancer": "Freelancer",
			"title": "Nadpis",
			"date": "Datum",
			"created_by": "Vytvořil",
			"max_length": "Maximální  délka: 1000 znaků",
			"chars_left": "Zbývajících znaků",
			"monday": "Pondělí",
			"tuesday": "Úterý",
			"wednesday": "Středa",
			"thursday": "Čtvrtek",
			"friday": "Pátek",
			"saturday": "Sobota",
			"sunday": "Neděle",
			"mon": "Po",
			"tue": "Út",
			"wed": "St",
			"thu": "Čt",
			"fri": "Pá",
			"sat": "So",
			"sun": "Ne",
			"yes": "Ano",
			"no": "Ne",
			"currency": "Kč",
			"filter": "Filtrovat",
			"calcel_filter": "Zrušit filtrování",
			"name": "Název",
			"confirm_delete": "Opravdu chcete smazat tuto šablonu?",
			"margin": "Odsazení",
			"add_shape_button": "Nová vrstva",
			"add_shape": "Přidat novou vrstvu",
			"shape_list": "Seznam vrstev",
			"diameter": "Průměr",
			"active": "Aktivní",
			"active_from": "Aktivní od",
			"active_to": "Aktivní do",
			"inactive": "Neaktivní",
			"set_active_date": "Aktivita šablony",
			"timer": "Časovač",
			"invalid_active_date_range": "Neplatný rozsah datumu",
			"circle": "Kruh",
			"frame": "Rám",
			"rectangle": "Obdélník",
			"triangle1": "Trojúhelník",
			"triangle2": "Trojúhelník",
			"triangle_side_length": "Délka strany",
			"corner_radius": "Zaoblení",
			"dynamicText": "Feed element",
			"imageFromElements": "Obrázek z elementu",
			"curvedText": "Text podél křivky",
			"circleText": "Text podél kruhu",
			"textWithElements": "Text s elementy",
			"background_settings": "Nastavení pozadí",
			"text_wrap": "Zalamování textu",
			"text_overflow": "Přetékání textu",
			"text_overflow_keep": "ponechat nezměněné",
			"text_overflow_fontsize": "zmenšit písmo",
			"text_overflow_layersize": "zvětšit vrstvu",
			"text_decoration": "Čára",
			"text_decoration_color": "Barva čáry",
			"text_decoration_linethickness": "Tloušťka čáry",
			"text_decoration_lineoverlap": "Přesah čáry",
			"text_decoration_none": "žádná",
			"text_decoration_underline": "pod",
			"text_decoration_overline": "nad",
			"text_decoration_linethrough": "přes",
			"text_direction": "Směr textu",
			"text_align": "Zarovnání textu",
			"text_align_left": "nalevo",
			"text_align_right": "napravo",
			"text_align_center": "vycentrovat",
			"text_valign": "Vertikální zarovnání",
			"text_valign_start": "nahoru",
			"text_valign_middle": "nastřed",
			"text_valign_end": "naspod",
			"height": "Výška",
			"aspect_size_ratio": "Zachovat poměr stran",
			"dash_length": "Délka čárkování",
			"dash_density": "Mezera",
			"dashedFrame": "Čárkovaný rám",
			"coordinate_x": "Souřadnice x",
			"coordinate_y": "Souřadnice y",
			"template_saved": "Šablona uložena.",
			"upload_error_unsupported_type": "Nepodporovaný typ souboru",
			"upload_error_large_file": "Soubor je příliš veliký. Max. velikost je 1MB.",
			"upload_error_image_too_big": "Rozměry obrázku jsou příliš veliké. Prosím změnšete obrázek a zkuste to znovu.",
			"active_templates": "Aktivní šablony",
			"type": "Typ",
			"file_too_big": "Soubor je příliš velký. Maximální velikost je 0,5 MB",
			"file": "Soubor",
			"bitmap": "Obrázek",
			"polygon": "Polygon",
			"bezier": "Křivka",
			"line": "Čára",
			"line_cap": "Zakončení čáry",
			"line_join": "Napojení čáry",
			"line_cap_round": "oblé",
			"line_cap_inherit": "-",
			"line_cap_butt": "plochou hranou",
			"line_cap_square": "čtvercové",
			"line_join_inherit": "-",
			"line_join_miter": "ostrý roh",
			"line_join_round": "oblé",
			"line_join_bevel": "zkosený roh",
			"collage_layouts": "Koláže",
			"add_layout_button": "Vlastní",
			"save_as_new_collage": "Uložit jako novou koláž",
			"preview_for_format": "Náhled pro formát",
			"no_custom_sets": "Nemáte zatím žádné vlastní sady obrázků",
			"custom_image_set_add": "Vytvořit sadu obrázků",
			"custom_image_set_remove": "Smazat sadu obrázků",
			"custom_image_set_remove_image": "Vymazat obrázek ze sady",
			"custom_image_set_selected_image": "Vybraný obrázek",
			"custom_image_set_selected": "Obrázky ze sady",
			"custom_set_name": "Název sady obrázků",
			"custom_image_set_no_set_selected": "Vyberte sadu",
			"custom_image_set_no_images_yet": "V této sadě nejsou zatím žádné obrázky.",
			"custom_image_set_no_image_selected": "Vyberte obrázek",
			"custom_image_set_uploaded": "Obrázek byl nahrán do sady",
			"custom_image_set_cannot_remove_is_used": "Obrázek je používán v některé ze šablon! Nelze smazat.",
			"custom_image_set_cannot_remove_success": "Obrázek byl smazán.",
			"custom_image_set_deleted_success": "Sada byla smazána",
			"custom_image_set_delete_set_is_used": "Nelze smazat tuto sadu, je použita v šablonách.",
			"scale": "Velikost",
			"adjust_size": "Přizpůsobení velikosti produktu",
			"enlarge": "Přizpůsobit velikost obrázku",
			"no_enlarge_nor_crop": "žádné přizpůsobení",
			"duplicate": "Duplikovat šablonu",
			"horizontal_flip": "Překlopit horizontálně",
			"vertical_flip": "Překlopit vertikálně",
			"flip": "Vertikálně",
			"flop": "Horizontálně",
			"rotation": "Pootočení",
			"elements": "Název elementu ze kterého vložit obsah",
			"xml_element_name": "Název elementu",
			"rating_xml_element": "Element s hodnocením",
			"rating_count_xml_element": "Element s počtem hodnocení",
			"rating_max_value": "Maximální hodnota v elementu s hodnocením",
			"rating_hide_empty": "Pouze jsou-li dostupné všechny elementy z feedu",
			"rating_min_stars": "Zobrazovat hodnocení od",
			"no_rating_yet": "Tento produkt dosud nikdo nehodnotil",
			"empty_element": "<ELEMENT JE PRÁZDNÝ>",
			"imagick_fonts": "Font",
			"imagick_fonts_family": "Filtrovat rodinu písem",
			"imagick_fonts_style": "Styl",
			"imagick_fonts_info": "Upozornění: některé fonty pro dynamický text nejsou v rychlém náhledu dostupné a tedy se nemusejí zobrazovat stejně jako vysledný vygenerovaný obrázek. Pro ukázku textu ve vybraném fontu použijte prosím tlačítko Náhled.",
			"render_preview": "Náhled",
			"rotate_right": "Pootočit doprava",
			"rotate_left": "Pootočit doleva",
			"image_enlargment": "Zvětšení obrázku",
			"format": "Formát",
			"first": "První",
			"last": "Poslední",
			"previews": "Náhledy",
			"more_previews": "Další náhledy",
			"edit_template": "Upravit šablonu",
			"no_templates_this_size": "Takové šablony zatím nemáte",
			"all_templates": "Všechny šablony",
			"reload_images": "Další náhledy",
			"show_unmodified": "Zobrazit neupravené",
			"show_modified": "Zobrazit upravené",
			"help": "Nápověda",
			"manage_templates": "Spravovat šablony",
			"inactive_templates": "Neaktivní šablony",
			"show_template": "Zobrazit šablonu",
			"no_image": "Produkt nemá obrázek.",
			"active_templates_only": "Pouze aktivní šablony",
			"unmodified_images": "Neupravené obrázky",
			"allow_cache": "Povolit cache",
			"no_products_in_query": "Výběry pro tuto šablonu neobsahují produkty. Zobrazujeme náhodné produkty z XML feedu.",
			"size_format": "Rozměr",
			"add_new": "přidat nový",
			"new": "Nový",
			"format_name": "Název formátu",
			"select_format": "Zvolte jeden z výstupních formátů...",
			"query_is_required": "Musíte vybrat alespoň jeden výběr produktu",
			"format_name_is_required": "Musíte vyplnit název rozměru",
			"width_is_required": "Šířka musí být větší než 0",
			"height_is_required": "Výška musí být větší než 0",
			"bad_file_format": "Nepovolený formát souboru",
			"name_is_required": "Musíte vyplnit název šablony",
			"error_loading_image": "Chyba při načítání obrázku",
			"confirm__bulk_delete": "Opravdu chcete smazat vybrané šablony?",
			"svg_change_colors": "Změnit barvy",
			"apply_color_change": "Aplikovat změnu barev",
			"load_image_error": "Nepodařilo se načíst obrázek",
			"badge": "Samolepka",
			"badges": "Samolepky",
			"icons": "Ikony",
			"search_badges_or_icons": "Hledat grafické prvky nebo ikony",
			"tags": "Štítky",
			"emoji": "Emoji",
			"change": "Změnit",
			"summer": "Léto",
			"borders": "Rámečky",
			"rating": "Hodnocení",
			"rating_source": "Zdroj hodnocení",
			"xml_element": "XML element",
			"depots_extension": "Rozšíření Depots",
			"depots_not_enabled": "Pro využití Depots jako zdroje hodnocení do obrazků jej aktivujte zdarma v <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"rating_from_element": "Hodnocení produktů",
			"star_symbol": "Symbol hvězdy",
			"active_only": "Pouze aktivní",
			"dynamic_only": "Pouze dynamické",
			"autumn": "Podzim",
			"showroom": "Náhledy šablon",
			"translate": "Posunutí",
			"crop": "Oříznout obrázek",
			"image_format": "Velikost obrázku produktu",
			"enlarge_hint": "Velikost obrázku produktu se upraví tak, aby vždy vyplnila požadovaný formát (při zachování poměru stran)",
			"crop_hint": "Pokud je obrázek produktu větší než nastavený formát, systém ho automaticky ořízne.",
			"winter": "Vánoce",
			"vertical_align_center": "Vycentrovat vertikálně",
			"horizontal_align_center": "Vycentrovat horizontálně",
			"enlarge_by": "Přizpůsobení velikosti obrázku dle",
			"by_width": "šířky obrázku",
			"by_height": "výšky obrázku",
			"by_smaller": "menšího rozměru obrázku",
			"by_bigger": "většího rozměru obrázku",
			"by_fit": "fit na rozměry výstupního formátu",
			"max_image_width": "Max šířka obrázku (px)",
			"max_image_height": "Max výška obrázku (px)",
			"by_max_size": "Nastavit max velikost (px)",
			"by_overscan": "Nastavit přesah (px)",
			"overscan": "Ochranná zóna",
			"overscan_hint": "Zde si můžete nastavit, o kolik pixelů se má obrázek zmenšit oproti velikosti původního formátu. Můžete zde nastavit kladnou i zápornou hodnotu. Kladnou hodnotou dosáhnete orámování původního obrázku nastavenou podkladovou barvou, zápornou zvětšení.",
			"enlarge_by_hint": "Zde si zvolte, podle jakého rozměru se mají obrázky produktů přizpůsobit do velikosti formátu. U všech zdrojových obrázků se vždy zachovává poměr stran.",
			"enlarge_by_blog_link": "Podrobnější vysvětlení",
			"error_save_template": "Při ukládání šablony se vyskytla chyba",
			"free-delivery": "Dny dopravy zdarma",
			"black-friday": "BLACK FRIDAY   &   CYBER MONDAY",
			"valentine": "Valentýn",
			"easter": "Velikonoce",
			"generic": "Univerzální šablony",
			"source_image": "Zdrojový obrázek",
			"sourceImage": "Zdrojový obrázek",
			"edit_shape": "Editace vrstvy",
			"new_shape": "Nová vrstva",
			"modal_close": "Zavřít",
			"done": "Hotovo",
			"general_error": "Chyba",
			"validation_error_fields.queries": "Nebyly vybrány produkty.",
			"validation_error_fields.shapes": "Šablona je prázdná.",
			"validation_error_queries": "Nebyly vybrány produkty.",
			"validation_error_size.id": "Chybí formát výsledného obrázku.",
			"validation_error_name": "Chybí název.",
			"validation_error_setName": "Chybí název sady",
			"validation_error_visual_similarity_templateids": "Vyberte šablony, ve kterých chcete hledat podobné produkty.",
			"shape_name": "Název vrstvy",
			"shape_badge_set_change": "Změnit set",
			"delete_shape": "Smazat vrstvu",
			"edit_done": "OK",
			"loading": "Načítám...",
			"low_contrast": "Nízký kontrast",
			"same_image_in_preview": "Stejný produkt v náhledu",
			"processed_at": "Datum zpracování",
			"total_processed": "zpracováno",
			"with_status_ok": "bez chyb",
			"with_status_error": "chybných",
			"without_images": "bez obrázků",
			"image_link": "Adresa obrázku",
			"content_length": "Velikost souboru",
			"probability": "Pravděpodobnost",
			"showGroup": "Skupina",
			"user_set": "Nastaveno uživatelem",
			"status_code": "stavový kód",
			"error": "chyba",
			"status_null": "?",
			"status_0_0": "V době zpracování nedostupný",
			"status_200_0": "V pořádku",
			"status_200_null": "V pořádku",
			"status_200_1": "Nulová velikost obrázku",
			"status_200_435": "Chybí šablona",
			"status_200_425": "Too Early",
			"status_200_450": "Neznámý formát",
			"status_500_0": "Interní chyba serveru",
			"status_503_0": "Služba je nedostupná",
			"status_400_0": "Chybný požadavek",
			"status_404_0": "Stránka nenalezena",
			"status_404_null": "Stránka nenalezena",
			"status_403_0": "Přístup odmítnut",
			"status_200_420": "Neznámý formát",
			"status_429_0": "Příliš mnoho požadavků",
			"status_200_465": "Výška nebo šířka obrázku přesahuje limit",
			"status_too_many_alts": "Mnoho alternativních obrázků",
			"status_same_images": "Produkty se stejným obrázkem",
			"status_empty_images": "Chybějící obrázky",
			"status_empty_images_description": "Ve vašem XML feedu chybí u produktů element IMGURL. Produkty nejsou propojené s obrázky, anebo obrázkové soubory úplně chybí. Důsledkem toho se nebudou ve vašem e-shopu ani ve srovnávačích zobrazovat. ",
			"status_unavailable_description": "Webová stránka, kde jsou obrázky uložené, nebyla nalezena.",
			"status_unsupported_mime_type_description": "Formát souboru, na který URL adresa odkazuje nepatří mezi standardní obrázkové formáty. Produktové obrázky se nebudou zobrazovat.",
			"status_invalid_url_description": "Produktové obrázky mohou být srovnávači zamítnuty, když je jejich URL adresa příliš dlouhá, nebo obsahuje znaky, které nejsou podle kritérií povolené. Častým problémem je diakritika či mezery v názvu obrázku.",
			"has_watermark_description": "Pokud chráníte vaše produktové obrázky vodoznaky, počítejte s tím, že reklamní systémy jako Heureka, GLAMI, FAVI či Google Nákupy vám tyto produkty nezobrazí.",
			"status_wrong_placement_description": "V ideálním případě by měly produkty na obrázku vyplňovat co největší plochu a být zarovnané na střed. V opačném případě se u nich ztrácí informační hodnota a působí nejednotně.",
			"status_poor_quality_images_description": "Pokud nejsou produktové obrázky dostatečně ostré, obsahují glitch nebo jsou jiným způsobem rozmazané, mohou svojí nedostatečnou kvalitou odradit zákazníky.",
			"status_seo_large_file_description": "<h3>Popis doporučení:</h3> Velikost obrázků přesahuje hranici 400 kB. Ve vašem e-shopu se to negativně projeví tak, že se obrázky budou dlouho načítat, což může vést ke zvýšené míře opuštěnosti.<br/><h3>Detail řešení:</h3> Feed Image Editor hromadně zkomprimuje příliš velké obrázky a sníží tak jejich velikost, aby se rychleji načítaly na webu. Víc se dočtete v článku na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/zlepsete-seo-obrazku-pomoci-automaticke-komprese\")>našem blogu</span>.",
			"status_few_alt_images_description": "<h3>Detailní popis problému:</h3> Srovnávače, na kterých chcete inzerovat, k produktům umožňují zobrazovat alternativní obrázky. K následujícím produktům přitom nemáte dostupný ani jeden alternativny obrázek.<br/><h3>Řešení:</h3> Doplňte do feedu alternativní obrázky a využijte možnosti srovnávačů na maximum. Jak k produktům vyhledat obrázky se dozvíte v článku na našem blogu.",
			"status_transparent_background_description": "Bílé pozadí produktových obrázků je nepsaným standardem u většiny reklamních systémů a srovnávačů. V případě, že některé z vašich obrázků mají průhledné pozadí, budou zamítnuté, anebo se jim pozadí doplní automaticky a budou vypadat kostrbatě.",
			"status_same_images_description": "Některé produkty mají stejné obrázky, například u velikostních variant oblečení, u ilustračních obrázků autosoučástek či nehmotných produktů. V ostatních případech to nedělá dobrý dojem.",
			"alternative_images_description": "Vaše produkty mají víc alternativních obrázků, než je povoleno srovnávačem. Tyto obrázky, které jsou navíc se v srovnávači nezobrazí. Zohledněte to a inzerujte ty nejatraktivnější alternativní obrázky.",
			"status_poor_quality_images": "Kvalita obrázku",
			"status_seo_large_file": "Velikost souboru s obrázkem z hlediska SEO",
			"status_few_alt_images": "Možnost doplnit alternativní obrázky",
			"status_all": "Všechny produkty",
			"status_unavailable": "Nedostupné obrázky",
			"status_invalid_url": "Nevalidní URL adresa",
			"status_unsupported_mime_type": "Nepodporovaný formát",
			"status_wrong_placement": "Pozice, zarovnání a velikost produktu na obrázku",
			"status_transparent_background": "Průhledné pozadí",
			"unsupported_mime_by_engines": "Obrázky nepodporované inzertním kanálem: Formát souboru, který jste zvolili pro export obrázků, není podporovaný zbožákem, na kterém chcete inzerovat. Výstupní formát změníte v nastaveních.",
			"supports_formats": "podporuje formáty",
			"with_problems": "s chybami",
			"clear_old_products": "Smazat staré produkty v db",
			"info_is_new": "Zatím žádné importované produkty. Zdá se, že na tomto projektu ješte neproběhla pravidla.",
			"info_no_data": "Nastaveným filtrům neodpovídají žádné produkty.",
			"info_not_processed_yet": "Zpracování a diagnostika probíhá průběžně během dne.",
			"info_apply_one_rule": "V připadě, že máte pro stejné produkty více šablon, aplikuje se pouze šablona s nejvyšší prioritou. Výběr produktů pro jednotlivé šablony můžete zvolit při editaci šablony v záložce produkty.",
			"filter_image_url": "Adresa obrázku",
			"filter_product_url": "Adresa produktu",
			"filter_product_urls": "Adresy produktů",
			"fulltext": "Fulltextové vyhledávání",
			"input_list": "Zadejte více adres oddělených čárkou nebo koncem řádku",
			"more": "Více",
			"less": "Méně",
			"filter_status_code": "Stavový kód",
			"filter_template": "Šablona",
			"filter_from": "Datum od",
			"filter_to": "Datum do",
			"filter_productname": "Název produktu",
			"filter_productid": "MERGADO id produktu",
			"filter_element": "Element",
			"filter_element_value": "Hodnota elementu",
			"filter_value_from": "Od",
			"filter_value_to": "Do",
			"filter_add": "Element",
			"filter_remove": "Zrušit <br/>všechny filtry",
			"filter_group": "Skupina",
			"filter_content_type": "Formát obrázku",
			"filter_content_length": "Velikost",
			"custom_filter": "Vlastní filtr",
			"preset_ranges": "Přednastavené rozsahy",
			"filter_mistake_set_by_user": "Stav nastavený uživatelem",
			"filter_correctness_percentage_offset": "Vzdálenost od okraje",
			"filter_has_alpha": "Průhledné pozadí",
			"filter_status_reason": "Důvod stavu",
			"filter_status": "Stav",
			"filter_probability": "Pravděpodobnost výskytu vodoznaku [%]",
			"filter_user_set_watermark": "Vodoznak v obrázku (uživatel)",
			"filter_user_set": "Stav nastavený uživatelem",
			"watermarks": "Vodoznaky",
			"images_quality": "Kvalita obrázků",
			"quality_status": "Stav kvality",
			"bad_quality_score": "Skóre špatné kvality",
			"good_quality": "Dobrá",
			"bad_quality": "Špatná",
			"middle_quality": "Střední",
			"diagnostics": "Diagnostika",
			"processed_alt_images": "Zpracovávaných alternativních obrázků",
			"processed_images": "Zpracovávaných obrázků",
			"problems": "Problémy",
			"warnings": "Varování",
			"recommendations": "Doporučení",
			"overview": "Přehled",
			"watermarks_removal": "Odstranění vodoznaků",
			"selected_watermark_pattern": "Tento obrázek bude použit jako vzor hledaného vodoznaku",
			"select_watermark_pattern": "Přidat do vzorů obsahující vodoznak",
			"user_set_objects": "Uživatelem označené pozice vodoznaků",
			"with_or_without_objects": "Označené vodoznaky",
			"with_objects": "S označenými vodoznaky",
			"without_objects": "Bez označených vodoznaků",
			"all": "Všechny",
			"view_mode": "Zobrazení",
			"problems_text": "U tolika produktů se <b>nezobrazují produktové obrázky</b>, protože se vyskytl minimálně jeden z těchto problémů:",
			"warnings_text": "U tolika produktů jsou <b>limity v zobrazování vašich obrázků</b>, protože se vyskytlo minimálně jedno z těchto varování:",
			"recommendations_text": "U tolika produktů se <b>nezobrazují produktové obrázky</b>, protože se vyskytl minimálně jeden z těchto problémů:",
			"one_product": "produkt",
			"less_than_five_products": "produkty",
			"products_count": "produktů",
			"image_id": "ID obrázku",
			"mistake_set_by_user": "Chyba nastavená uživatelem",
			"correctness_percentage_offset": "Vzdálenost od okraje",
			"has_alpha": "Průhlednost",
			"status_reason": "Důvod stavu",
			"status": "Stav",
			"updated_at": "Aktualizováno",
			"no_alpha": "Ne",
			"with_alpha": "Ano",
			"info_status_suspicious": "Nelze rozpoznat zda je obrázek záměrně takto umístěn",
			"vertical_image": "Vertikální obrázek",
			"horizontal_image": "Horizontální obrázek",
			"image_down": "Obrázek dole",
			"image_up": "Obrázek nahoře",
			"image_right": "Obrázek napravo",
			"image_left": "Obrázek nalevo",
			"image_in_the_middle": "Obrázek uprostřed",
			"image_could_not_be_read": "Obrázek nelze přečíst",
			"unknown_image_format": "Neznámý formát",
			"option_false": "Ne",
			"option_true": "Ano",
			"option_not_set": "Hodnota nenastavena",
			"mistake_by_user_successfully_changed": "Hodnota změněna",
			"status_N/A": "Podezřelý",
			"status_ERROR": "Chyba",
			"status_OK": "V pořádku",
			"status_NOT_OK": "Není v pořádku",
			"status_NOT_DETECTED": "Nedetekován",
			"importance_HIGH": "Vysoká",
			"importance_MEDIUM": "Střední",
			"importance_SMALL": "Nízká",
			"filter_is_active": "fiter je aktivní",
			"export_to_csv": "Exportovat",
			"csv_download_started": "Vytvářím csv, prosím čekejte",
			"csv_download_success": "Soubor byl vytvořen",
			"csv_download_error": "Došlo k chybě při exportu do csv",
			"shop_link": "Odkaz do e-shopu",
			"unmodified_link": "Neupravený obrázek",
			"modified_link": "Obrázek přes šablonu",
			"total_products": "Produktů",
			"total_images": "Obrázků",
			"total_alt_images": "Alternativních obrázků",
			"total_products_info": "Celkem produktů importovaných z MERGADA",
			"no_products_yet": "Zatím žádné importované produkty k této šabloně.",
			"total_processed_products_info": "Celkem před-zpracovaných produktů",
			"product": "Produkt",
			"product_category": "Kategorie",
			"product_links": "Odkazy",
			"eshop_product": "Produkt v E-shopu",
			"barcode_lookup": "Produkt v BarcodeLookup",
			"product_name": "Produkt",
			"product_no": "Číslo produktu",
			"product_code": "Kód produktu",
			"product_image": "Obrázek",
			"product_template": "Šablona",
			"product_image_link": "Adresa obrázku",
			"element_item_id": "ID produktu",
			"element_url": "Adresa do E-shopu",
			"element_cpc": "CPC",
			"element_name": "Název produktu",
			"element_img_url": "Adresa výstupního obrázku",
			"element_img_url_input": "Adresa vstupního obrázku",
			"element_alt_img_url": "Adresa výstupního alternativního obrázku",
			"element_alt_img_url_input": "Adresa vstupního alternativního obrázku",
			"element_price_vat": "Cena s DPH",
			"element_delivery_date": "DELIVERY_DATE",
			"element_manufacturer": "Výrobce",
			"element_categorytext": "Kategorie",
			"element_ean": "EAN",
			"element_productno": "Číslo produktu",
			"element_accessory": "Příslušenství",
			"element_gift": "Dárek",
			"element_itemgroup_id": "ITEMGROUP_ID",
			"advanced_search": "Rozšírené vyhledávání",
			"export_is_ready": "Export je připravený. ",
			"download": "Stáhnout",
			"please_wait_generating_export": "Prosím čekejte, generuji export",
			"please_wait_generating_export2": "Toto okno můžete zavřít. V okamžiku, kdy bude export připravený zobrazí se vám notifikace s odkazem ke stažení.",
			"click_to_download_export": "Stažení exportu provedete kliknutím na tlačítko Stáhnout",
			"exported": "Exportováno",
			"close": "Zavřít",
			"n_products": "produktů",
			"template_exported": "Šablona byla exportována",
			"export_template": "Exportovat šablonu",
			"import_template": "Importovat šablonu",
			"link_image_url": "Adresa obrázku",
			"link_fie": "Obrázek z Feed Image Editoru",
			"link_mergado": "Produkt v MERGADU",
			"link_eshop": "Produkt v E-shopu",
			"template_not_found": "Šablona nenalezena!",
			"template_preview": "Náhled",
			"template_is_dynamic": "Šablona s dynamickými prvky",
			"input_width": "Šířka vstup. obrázku",
			"input_height": "Výška vstup. obrázku",
			"product_content_type": "Formát obrázku",
			"product_content_length": "vstupní velikost [kB]",
			"rendered_content_length": "výstupní velikost [kB]",
			"copy_to_clipboard": "Zkopírovat do schránky",
			"copy_mergado_query": "Zkopírovat dotaz pro MERGADO do schránky",
			"copied_to_clipboard": "zkopírováno",
			"products_per_page": "Počet produktů na stránce náhledy",
			"layer_copied": "Vrstva byla zkopírována do schránky",
			"ask_save_before_leave": "Pokud odejdete, vaše změny nemusí být uloženy.",
			"ask_save_before_leave_title": "Odejít bez uložení?",
			"ask_save_before_leave_leave": "Odejít",
			"ask_save_before_leave_stay": "Zůstat",
			"history_undo": "Zpět",
			"history_redo": "Znovu",
			"history_initial": "Vrátit vše",
			"settings": "Nastavení",
			"confirm_delete_format": "Opravdu smazat formát",
			"confirm_delete_format_yes": "Ano",
			"confirm_delete_format_no": "Ne",
			"templates_having_this_size": "Šablony s tímto formátem",
			"project_settings": "Nastavení projektu",
			"ui_settings": "Nastavení uživatelského rozhraní",
			"output_image_format": "Nastavení výstupního formátu",
			"output_image_compression": "Komprese výstupního obrázku",
			"auto_compression_to_size": "Automatická komprese do velikosti",
			"group_by_image": "Seskupovat podle obrázku",
			"products_per_page_on_list": "Produktů na stránce",
			"ask_before_leave": "Před ukončením editoru se ptát na uložení změn",
			"settings_value": "hodnota",
			"settings_update_success": "Nastavení uloženo",
			"settings_update_error": "Došlo k chybě při ukládání nastavení",
			"save_sizes_success": "Formát uložen",
			"save_sizes_error": "Došlo k chybě při ukládání formátu",
			"different_hash": "Údaje nemusejí být aktuální",
			"filtered_items": "Vyfiltrováno",
			"set_template_active_date_success": "Datum nastaveno",
			"set_template_active_date_error": "Nepodařilo se nastavit datum",
			"from_date": "od",
			"to_date": "do",
			"is_active": "je aktivní",
			"not_active": "není aktivní",
			"is_date_limited": "Aktivní od - do",
			"active_now": "Aktivní hned",
			"set_timer": "Načasovat spuštění",
			"show_more": "Více...",
			"show_less": "Méně...",
			"output_image_preview": "Náhled výstupního obrázku",
			"output_image_content_length": "Velikost",
			"original_output_image_content_length": "Původně",
			"less_than_original": "méně než původně",
			"more_than_original": "více než původně",
			"about": "o",
			"has_no_watermark": "Neobsahuje vodoznak",
			"has_watermark": "Obsahuje vodoznak",
			"watermark_status": "Vodoznak v obrázku",
			"hiding_products": "Skrývání produktů",
			"hide_products_by_filter": "Skrýt produkty podle filtru",
			"unhide_products": "Odkrýt",
			"hidden_by_filter": "Skryto podle filtru",
			"hide_by_has_watermark": "Skrýt produkty s vodoznaky",
			"hide_by_wrong_placement": "Skrýt produkty se špatným umístěním obrázku",
			"hide_by_low_quality": "Skrýt produkty s nízkou kvalitou",
			"hide_by_seo_large_file": "Skrýt produkty s velkým obrázkem z hlediska SEO",
			"filter_content_length_gt": "Velikost větší než ... [kB]",
			"filter_content_length_lt": "Velikost menší než ... [kB]",
			"set_by_user": "Nastaveno uživatelem",
			"filter_empty_content": "Prázdný obsah obrázku",
			"filter_no_image": "Bez obrázku",
			"is_collage": "Rozložení",
			"all_available_only": "Pouze jsou-li dostupné všechny alternativní obrázky",
			"single_image": "Jeden produktový obrázek",
			"collage_layout": "Zvolte rozvržení",
			"export_layouts": "Exportovat rozložení",
			"import_layouts": "Importovat rozložení",
			"export_gradients": "Exportovat gradienty",
			"import_gradients": "Importovat gradienty",
			"main_image": "Obrázek",
			"alt_image": "Alt",
			"alternative_images": "Alternativní obrázky",
			"save_layouts_error": "Došlo k chybě při ukádání",
			"save_layouts_success": "Uloženo",
			"delete_layouts_error": "Při mazání rozvržení došlo k chybě. Rozložení je používáno v šabloně.",
			"delete_layout_image_error": "Chyba při mazání obrázku z rozložení",
			"delete_layouts_success": "Smazáno",
			"add_layout_image_success": "Obrázek přidán do rozložení",
			"add_layout_image_error": "Došlo k chybě při přidávání obrázku rozložení",
			"create_default_layouts": "Znovu vytvořit výchozí sadu rozložení",
			"create_default_layouts_success": "Výchozí rozložení úspěšne vytvořeno",
			"create_default_layouts_error": "Chyba při vytváření výchozího rozložení",
			"delete_all_unused": "Smazat všechny nepoužívané",
			"delete_all_unused_success": "Úspěšně smazáno",
			"delete_all_unused_error": "Chyba při mazání",
			"layout_name": "Název rozložení",
			"selected_layout_image": "Vybraný obrázek",
			"add_layout": "Přidat rozložení",
			"delete_layout": "Smazat rozložení",
			"delete_layout_image": "Smazat obrázek rozložení",
			"add_layout_image": "Přidat obrázek rozložení",
			"save_all_layouts": "Uložit všechna rozložení",
			"save_layout": "Uložit rozložení",
			"padding_px": "Odsazení obrázku [px]",
			"assigned_image": "Přiřazený obrázek",
			"units": "Jednotky",
			"layout_pos": "Umístění",
			"layout_size": "Rozměry",
			"add_layout_success": "Nové rozložení přidáno",
			"add_layout_error": "Došlo k chybě při přidávání rozložení",
			"template_sizes": "Rozměry výstupního obrázku",
			"save_order": "Uložit pořadí",
			"save_settings_order_success": "Pořadí nastavní uloženo",
			"save_settings_order_error": "Chyba při ukládání pořadí",
			"import_template_success": "Šablona importována",
			"import_template_error": "Při importu šablony došlo k chybě",
			"representative_colors": "Reprezentativní barvy z obrázku",
			"shortcuts": "Klávesové zkratky",
			"shortcut_ins": "Vložit novou vrstvu",
			"shortcut_del": "Smazat vrstvu",
			"shortcut_save": "Uložit šablonu",
			"shortcut_undo": "Editace zpět",
			"shortcut_redo": "Editace znovu",
			"shortcut_copy": "Kopírovat vrstvu",
			"shortcut_paste": "Vložit vrstvu",
			"product_is_rendering": "Generuji náhled",
			"product_is_loading": "Načítám produkt",
			"is_saving": "Ukládám",
			"invalid_filed_value": "Neplatná hodnota pole",
			"value_not_set": "nenastaveno",
			"font_not_found": "Font nebyl nalezen. Nahrazeno defaultním.",
			"radius": "Poloměr",
			"gradient_type_linear": "Lineární",
			"gradient_type_radial": "Radiální",
			"no_gradient": "Žádný gradient",
			"select_gradient": "Vybrat gradient",
			"select_gradients": "Vyberte gradienty",
			"save_as_new_gradient": "Uložit jako nový gradient",
			"info_gradients_not_saved": "Změny v gradientu ještě nejsou uloženy",
			"gradient": "Gradient",
			"gradients": "Gradienty",
			"confirm_remove_gradient": "Smazat tento gradient?",
			"palettes": "Palety barev",
			"predefined_colors": "Předdefinované barvy",
			"brand_colors": "Barvy brandu",
			"custom_colors": "Vlastní palety",
			"select_palette": "Vybrat paletu",
			"extract_colors_from_image": "Extrahovat barvy z obrázku",
			"add_to_custom_palettes": "Přidat k vlastním paletám",
			"save_custom_colors": "Uložit vlastní barvy",
			"save_as_default": "Uložit jako výchozí",
			"saved": "Uloženo",
			"no_changes": "Žádné změny",
			"no_custom_palettes": "Zatím nemáte žádné vlastní palety",
			"create_layer_group": "Vytvořit skupinu vrstev",
			"group": "Seskupit",
			"ungroup": "Oddělit",
			"delete_layer_group": "Zrušit skupinu vrstev",
			"toggle_visibility": "Přepnout viditelnost",
			"delete_layers": "Smazat vrstvy",
			"delete_layer": "Smazat vrstvu",
			"duplicate_layer": "Duplikovat vrstvu",
			"duplicate_layers": "Duplikovat vrstvy",
			"edit_layer": "Upravit vrstvu",
			"lock_layer": "Zamknout vrstvu",
			"unlock_layer": "Odemknout vrstvu",
			"thickness": "Tloušťka",
			"brightness": "Jas",
			"contrast": "Kontrast",
			"show_products": "Zobrazit produkty",
			"reset_effects": "Zrušit efekty",
			"auto_level": "Automatické vyvážení barev",
			"alpha": "Průhlednost",
			"save_as_query": "Uložit jako<br/> výběr",
			"save_as_query_title": "Uložit jako výběr",
			"fie_query_type": "Typ",
			"fie_query_name": "Název výběru",
			"fie_query_element": "Název nového elementu v MERGADU",
			"fie_query_filter": "Produktový filtr",
			"fie_query_is_active": "Aktivní",
			"query_in_use": "Tento výběr je používán v šabloně",
			"fie_queries": "Výběry",
			"fie_queries_info": "Výběry - TODO: napověda",
			"no_fie_queries_yet": "Zatím nemáte žádné výběry produktů. Můžete je vytvorit v sekci produkty.",
			"toggle_active": "Přepnout aktivní/neaktivní",
			"set_active": "Přepnout aktivní",
			"set_inactive": "Přepnout neaktivní",
			"image": "Obrázek",
			"mergado_connection_verifying": "Ověřuji spojení s MERGADEM",
			"show_in_mergado": "Ukázat v MERGADU",
			"mergado_queries": "Výběry",
			"mergado_products": "Produkty",
			"mergado_formats": "Formáty",
			"mergado_elements": "Elementy",
			"output_image_element": "Výstupní obrázkový element",
			"output_image_hidden_warning": "Pozor, výstupní obrázkový element pro tento typ exportu je skrytý",
			"not_empty_error": "Toto pole je povinné",
			"drop_shadow": "Stín",
			"shadow_color": "Barva stínu",
			"shadow_opacity": "Průhlednost",
			"shadow_sigma": "Rozmazání",
			"shadow_offset": "Posunutí",
			"shadow_xoffset": "X",
			"shadow_yoffset": "Y",
			"effect_sensitivity": "Citlivost efektu",
			"sensitivity": "citlivost",
			"LOW": "nízká",
			"MEDIUM": "střední",
			"HIGH": "vysoká",
			"too_big_for_upscale": "Obrázek je větší než 600 x 600 pixelů, vylepšení rozlišení není možné aplikovat. Zkuste prosím načíst jiný náhodný obrázek.",
			"only_main_image": "pouze hlavní obrázek",
			"other_effects": "Další efekty",
			"flood_fill_points": "Body",
			"fuzz": "Rozptyl",
			"heureka_175x175": "Heureka – doporučené rozměry",
			"heureka_4096x4096": "Heureka – maximální rozměry",
			"zoot_1000x745": "Zoot – minimální rozměry",
			"zoot_1907x2562": "Zoot – doporučené rozměry",
			"zbozi_425x440": "Zboží.cz – minimální rozměry",
			"zbozi_600x800": "Zboží.cz – minimální rozměry (bazarové zboží)",
			"google_100x100": "Google Merchants – minimální rozměry",
			"google_250x250": "Google Merchants – minimální rozměry u oblečení",
			"google_500x500": "Google Merchants – minimální rozměry *od 31.1.2027",
			"google_1500x1500": "Google Merchants – doporučené rozměry",
			"glami_400x400": "GLAMI – minimální rozměry",
			"glami_1500x1500": "GLAMI – doporučené rozměry",
			"alza_600x600": "ALZA – minimální rozměry",
			"alza_1000x1000": "ALZA – minimální doporučené rozměry",
			"alza_1300x1300": "ALZA – maximální doporučené rozměry",
			"favi_600x600": "FAVI – minimální rozměry",
			"favi_1000x1000": "FAVI – doporučené rozměry",
			"biano_400x400": "BIANO – minimální rozměry",
			"biano_1500x1500": "BIANO – doporučené rozměry",
			"shopalike_250x250": "Shopalike – minimální rozměry",
			"shopalike_1024x1024": "Shopalike – doporučené rozměry",
			"instagram_1024x1024": "Instagram – doporučené rozměry",
			"instagram_1080x1080": "Instagram",
			"instagram_1080x1350": "Instagram",
			"instagram_1080x566": "Instagram",
			"instagram_1080x1920": "Instagram",
			"instagram_1440x1800": "Instagram",
			"instagram_1440x2560": "Instagram",
			"allegro_500x500": "Allegro – minimální rozměry",
			"allegro_2560x2560": "Allegro – maximální rozměry",
			"facebook_1024x1024": "Facebook – doporučené rozměry",
			"facebook_500x500": "Facebook – minimální rozměry",
			"facebook_600x600": "Facebook",
			"facebook_1080x1080": "Facebook",
			"facebook_1200x1200": "Facebook",
			"facebook_1080x1350": "Facebook",
			"facebook_1200x628": "Facebook",
			"facebook_1440x1440": "Facebook",
			"facebook_1440x1800": "Facebook",
			"facebook_1440x2560": "Facebook",
			"modio_500x500": "Modio – minimální rozměry",
			"modio_1024x1024": "Modio – doporučené rozměry",
			"modio_2048x2048": "Modio – maximální rozměry",
			"mall_1280x1024": "Mall – minimální rozměry",
			"mall_2000x2000": "Mall – maximální rozměry",
			"kaufland_1024x1024": "Kaufland – minimální rozměry",
			"kaufland_2048x2048": "Kaufland – doporučené rozměry",
			"snapchat_200x200": "Snapchat – minimální rozměry",
			"pinterest_200x300": "Pinterest – minimální rozměry",
			"pinterest_600x900": "Pinterest – minimální rozměry",
			"pinterest_1000x1500": "Pinterest – doporučené rozměry",
			"pinterest_1080x1920": "Pinterest – doporučené rozměry",
			"pinterest_1080x1080": "Pinterest",
			"find_format": "Najít formát",
			"custom_formats": "Vlastní formáty",
			"other_formats": "Další formáty",
			"elements_availability": "Dostupnost elementů v dynamických šablonách",
			"product_elements": "Elementy",
			"filter_missing_elements": "Filtrovat chybejíci nebo prázdné elementy",
			"only_updated_products": "Pouze produkty které prošly pravidly po uložení šablony",
			"ok": "V pořádku",
			"empty_elements": "Prázdné elementy",
			"toggle_snap_to_guides": "Přichytávat",
			"toggle_snap_to_grid": "Přichytávat k mřížce",
			"toggle_snap_to_element": "Přichytávat k prvku",
			"show_grid": "Mřížka",
			"snap_strength": "Pevnost přichycení",
			"is_anim_gif": "Animovaný GIF",
			"outpainting": "Outpainting",
			"frames_delay": "Zpoždění mezi smínky [ms]",
			"loops_delay": "Zpoždění na konci [ms]",
			"info_no_active_template": "Aktuálně nemáte aktivní ani jednu šablonu. Feed Image Editor začne pracovat poté, co nějakou aktivujete.",
			"info_no_template": "<b>Nemáte vytvořenou žádnou šablonu.</b><br/>Vyberte si jednu z předchystaných šablon z galerie, nebo si vytvořte vlastní.",
			"info_workshop": "Naučte se, jak využívat využívat Feed Image Editor na sto procent. Přihlaste se na školení o image marketingu, které pro vás zdarma pořádáme. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/skoleni\")>Zjistěte více</span>.",
			"replace_color": "Nahrazení barev",
			"target_color": "Nahradit barvu",
			"replace_by_color": "Barvou",
			"add_point": "Přidat bod",
			"info_no_points": "Body můžete pridat kliknutím na plátno",
			"projects_overview": "Přehled projektů",
			"system": "System",
			"project_info": "Projekt",
			"templates": "Šablony",
			"random_images": "Náhodné obrázky",
			"rules": "Pravidla",
			"queries": "Výběry",
			"rabbit": "RabbitMQ",
			"points_coordinates": "Relativní pozice bodů",
			"no_images_found": "Nenalezeny žadné produkty obsahující obrázky",
			"show_helper": "Zobrazovat pomocníka",
			"disable_helper": "Nezobrazovat pomocníka",
			"disable_wheelzoom": "Zakázat zoom kolečkem myši",
			"helper_ok": "V pořádku",
			"helper_close": "Už více nezobrazovat",
			"helper": "Pomocník",
			"need_help_title": "Potřebujete s něčím poradit?",
			"need_help_text": "V případě jakýchkoliv podnětů či problémů obraťte se prosím naši podporu <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"bezier_no_points": "<ul><li class=\"right-arrow-marker\">Nový bod křivky přidáte kliknutím na plátno</li></ul>",
			"bezier_add_points": "<ul><li class=\"right-arrow-marker\">Klikněte na plátno, podržte tlačítko stisknuté a nastavte kontrolní body tažením myši. Poté uvolněte tlačítko a můžete nastavit další body.</li></ul>",
			"bezier_unselect": "<ul><li>Chcete-li změnit aktivní vrstu, můžete použít pravé tlačítko myši nebo se přepnout v seznamu vrstev.</li></ul>",
			"has_reflection": "Odraz",
			"angle": "Úhel",
			"reflection_offset": "Offset",
			"reflection_opacity": "Průhlednost",
			"reflection_flip": "Překlopení",
			"helper_no_queries": "<ul><li class=\"info-marker\">Zvolte produktový výběr, na který se bude šablona aplikovat. Na vyhledání výběru použijte filtr.</li></ul>",
			"helper_one_query": "<ul><li>Zvolit můžete více výběrů.</li></ul>",
			"helper_at_least_one_query": "<ul><li>Zvolené výběry najdete vždy nahoře v seznamu.</li></ul>",
			"helper_zero_products_query": "<ul><li class=\"exclamation-marker\">Zvolený výběr neobsahuje žádné produkty.</li></ul>",
			"helper_no_format": "<ul><li class=\"info-marker\">Zvolte jeden z přednastavených výstupních formátů. Vlastní formát si vytvoříte na konci seznamu, nebo v Nastaveních.</li></ul>",
			"helper_format_selected": "<ul><li>Zvolte jednu z možností přizpůsobení obrázků.</li><li>Šířku přesahu upravte ručně podle potřeby.</li></ul>",
			"helper_no_layer": "<ul><li class=\"info-marker\">Kliknutím na Nová vrstva do obrázků přidáte text, štítky, grafiku a další prvky.</li></ul>",
			"helper_at_least_one_layer": "<ul><li>Pořadí vrstiev změníte {ArrowVIcon} přesunutím.</li><li>Vrstvy s elementy mají pevné pořadí nahoře v plátně.</li><li>Nezapomeňte si šablonu pojmenovat a uložit.</li></ul>",
			"helper_two_more_layers": "<ul><li>Podržte <span class=\"framed\">CTRL</span> a kurzorem označte více vrstev. Tlačítkem {GroupIcon} je seskupíte do jedné vrstvy. Stejným tlačítkem vrstvy nazpět rozdělíte.</li><li>Vodicí linky vám usnadní zarovnávání vrstev. Aktivujete a deaktivujete je tlačítkem {MagnetIcon}</li></ul>",
			"layers": "Vrstvy",
			"brush_spacing": "Rozestup",
			"brush_color": "Barva štětce",
			"brush_pattern": "Vzor",
			"brush_pattern_color": "Barva vzoru",
			"brush_rotate_pattern": "Natáčet vzor",
			"linewidth_profile": "Profil šířky čáry",
			"uniform": "stejnoměrný",
			"fade_out": "postupně zeslabit",
			"fade_in": "postupně zesílit",
			"fading": "na koncích zeslabit",
			"zoom_in": "zvětšit",
			"zoom_out": "zmenšit",
			"token_not_provided": "Chyba ověření - token není poskytnut",
			"toast_online_call": "Nevíte si rady, nebo potřebujete pomoct s vytvořením první obrazové kampaně? Domluvte si <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call s Markem</span>, který vám rád poradí, jak využít Feed Image Editor na maximum.",
			"online_call_header": "Chcete pomoc s nastavením nebo inspiraci pro vaše kampaně?",
			"online_call": "Rezervujte si krátkou bezplatnou konzultaci s Markem. Ukáže vám nejlepší postupy pro váš typ e-shopu, pomůže s nastavením a zodpoví vše, co vás zajímá.",
			"watermark_mask": "Maska vodoznaku",
			"watermark_masked_image": "Vodoznak",
			"watermark_group": "Skupina vodoznaků",
			"watermark_groups": "Skupiny vodoznaků",
			"watermark_methods": "Metody odstranění vodoznaků",
			"create_new_group": "Vytvořit novou skupinu",
			"new_group": "Nová skupina",
			"required_field": "Povinné pole",
			"no_watermark_masks": "Zatím nemáte označené žádné vodoznaky",
			"downloaded": "Staženo",
			"status_ok": "Stav v pořádku",
			"waiting_to_process": "Čeká na zpracování",
			"inpaint_error": "Chyba odstaranění vodoznaku",
			"watermark_group_not_selected": "Nejprve vyberte skupinu vodoznaků",
			"background": "Pozadí",
			"remove_background": "Odstranit pozadí",
			"solid_bg": "Jednobarevné",
			"light_bg": "Světlé pozadí",
			"dark_bg": "Tmavé pozadí",
			"background_colors": "Barvy",
			"background_shade": "Odstín pozadí",
			"not_transparent_bg": "Neprůhledné pozadí",
			"transparent_bg": "Průhledné pozadí",
			"multicolor_bg": "Vícebarevné",
			"status_not_recommended_colorspace": "Barevné modely",
			"not_recommended_colorspace": "Barevné modely",
			"not_recommended_colorspace_description": "Vaše obrázky jsou v barevném modelu CMYK, který není vhodný pro zobrazování na obrazovkách počítačů a mobilních zařízení. Takovéto obrázky odradí vaše zákazníky. Překonvertujte obrázky do barevného modelu RGB.",
			"status_unsupported_background": "Pozadí obrázku",
			"unsupported_background": "Pozadí obrázku",
			"unsupported_background_description": "Srovnávače zboží a inzertní sítě se liší v požadavcích na pozadí produktových obrázků. Velká část z nich vyžaduje jednobarevné bílé pozadí. Pokud na ně odešlete obrázky nebo produktové fotografie s barevným pozadím, nedostanete tyto produkty do inzerce. Na některých srovnávačích to ale naopak možné je.",
			"set_watermark_group_first": "Nejprve nastavte skupinu vodoznaků!",
			"unknown_preview_image_error": "Chyba načítání obrázku",
			"render_preview_error_6": "Neznámá doména",
			"render_preview_error_1": "Zdrojový obrázek je prázdný",
			"render_preview_error_420": "Neznámý formát",
			"render_preview_error_450": "PNG obrázek má špatný CRC",
			"render_preview_error_28": "Server na kterém je obrázek neodpovídá",
			"render_preview_error_35": "Chyba SSL",
			"first_steps_wizard": "Průvodce prvním nastavením",
			"skip_wizard": "Nepotřebuji průvodce, chci přejít do aplikace",
			"close_wizard": "Zavřít průvodce",
			"input_elements_map": "Nastavení vstupních elementů",
			"input_output_format": "Nastavení vstupního a výstupního formátu",
			"first_steps_create_template": "Hotovo. Vše je připraveno pro tvorbu první šablony.",
			"first_step_info": "Vítejte v aplikaci Feed Image Editor, která vám pomůže s hromadní úpravou produktových obrázků vašeho e-shopu pro marketplace, sociální sítě a zbožové srovnávače.<br/>V prvním kroku si prosím vyberte kanál, na kterém chcete inzerovat:",
			"first_step_info_old": "Vítejte v aplikaci Feed Image Editor, která vám pomůže s úpravou obrázků ve vašem e-shopu.<br/>Jako první krok prosím zkontrolujte, jestli jsme vybrali správné elementy z vašeho feedu pro použití v editoru. Poté se již můžete hned pustit do tvorby první šablony.",
			"next_step": "Další krok",
			"previous_step": "Předešlý krok",
			"input_format": "Vstupní formát",
			"output_format": "Výstpuní formát",
			"preferred_product_preview": "Náhled preferovaného produktu",
			"date_placeholder": "DD. MM. RRRR",
			"today": "Dnes",
			"news_box_header": "Podívejte se na novinky z aplikace",
			"news_box_body": "<h4>Upravujte produktové obrázky přímo v chatu</h4><p>Feed Image Editor má nyní MCP server – propojení s AI asistenty jako Claude nebo ChatGPT. Místo klikání v rozhraní stačí zadat příkaz v chatu a agent za vás:<ul><li>nastaví šablony a parametry úprav</li><li>přiřadí produkty podle výběru</li><li>upraví rozměry, odstraní pozadí, zvýší rozlišení</li></ul></p><p>Pokud už máte AI asistenta připojeného přes Mergado MCP, Feed Image Editor MCP funguje automaticky a bez dalšího nastavování. V případě, že jste ještě s MCP nepracovali, klikněte na odkaz a během chvilky ho napojíte.</p>",
			"news_box_body_link": "Zjistit více →",
			"select_template_queries": "Nejdříve vyberte, na jaké produkty chcete šablonu aplikovat",
			"set_output_image_size": "Nastavte si velikost výstupních obrázků",
			"select_from_template_gallery": "Můžete si vybrat některou z našich připravených šablon",
			"main_image_or_collage": "Zvolte si, jestli chcete mít na výstupu pouze hlavní obrázek, nebo koláž hlavního a alternativních obrázků",
			"main_image_on_canvas_placement": "Umístěte hlavní obrázek na plátno",
			"set_collage_layout": "Nastavte výsledný vzhled koláže. Pro lepší efekt doporučujeme aktivovat funkci odstranění pozadí.",
			"set_anim_gif": "Nastavte výsledný vzhled animovaného GIFu",
			"position_and_rotation": "Pozice a pootočení",
			"apply_ai_effects_or_filters": "Aplikujte AI efekty nebo filtry na produktový obrázek",
			"editor_step_5": "Zvolte si, jestli má být šablona spuštěná hned po vytvoření, nebo až ve vybraný den",
			"editor_step_6": "Vizuální podobnost obrázků",
			"editor_step_7": "Přidejte si další vrstvy s grafickými prvky",
			"helper_tips": "<ul><li>Chtěli byste v appce používat vlastní font? Napište nám na support@feedimageeditor.com</li><li>Víte, že v editoru můžete používat klávesové zkratky?<div class='quote'><span class='framed'>Ins</span><span>Vložit novou vrstvu</span><br/><span class='framed'>Del</span><span>Smazat vrstvu</span><br/><span class='framed'>Ctrl + s</span><span>Uložit šablonu</span><br/><span class='framed'>Ctrl + z</span><span>Editace zpět</span><br/><span class='framed'>Ctrl + y</span><span>Editace znovu</span><br/><span class='framed'>Ctrl + c</span><span>Kopírovat vrstvu</span><br/><span class='framed'>Ctrl + v</span><span>Vložit vrstvu</span></div></li></ul>",
			"more_fonts": "Chtěli byste v appce používat vlastní font? Napište nám na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"editor_step_0": "Vyberte typ šablony",
			"layout": "Rozvržení obrázků",
			"autoonoff": "Plánovač aktivity",
			"success": "V pořádku",
			"zoom": "Zvětšení",
			"pan": "Posunutí",
			"draw": "Kreslit",
			"move": "Posunout",
			"reset_zoom": "Reset zoom",
			"queued_at": "Zařazeno do fronty",
			"score": "Skóre",
			"ai_tools": "AI nástroje",
			"missing_symbols": "Tento font neobsahuje všechny symboly, živý náhled a vyrenderovaný obrázek se mohou lišit.",
			"characters": "znaky",
			"recently_used": "Nedávno použité",
			"set_background": "Nastavit pozadí",
			"filters": "Filtry",
			"remove_background_error": "Nastala chyba při odstraňování pozadí obrázku",
			"cannot_remove_background": "U daného obrázku nedokážeme odstranit věrohodně pozadí",
			"object_to_image_ratio": "Objekt/obrázek",
			"template_id": "template id",
			"disable_show_overlap": "Nezobrazovat zónu v náhledu",
			"font_example": "Příliš žluťoučký kůň úpěl ďábelské ódy.",
			"unsupported_mime_type": "Nepodporovaný formát",
			"unsupported_file_size": "Soubor je příliš velký",
			"selection": "Výběr",
			"is_transparent": "Průhledné pozadí",
			"is_light_bg": "Světlé pozadí",
			"orientation": "Orientace obrázku",
			"portrait": "Na výšku",
			"landscape": "Na šířku",
			"bg_color_distance": "Barevná vzdálenost",
			"small_distance": "malá",
			"big_distance": "velká",
			"medium_distance": "střední",
			"bg_color": "Barva pozadí",
			"create": "Vytvořit",
			"create_predefined_fie_queries_title": "Které z následujících výběrů si přejete vytvořit?",
			"create_predefined_fie_queries_text": "Vytvořit předdefinované FIE výběry?",
			"active_supereffect": "Aktivní superefekt",
			"not_number": "Není číslo",
			"prepared_text": "Předchystaný text",
			"get_now": "akce",
			"discount": "sleva",
			"discount_and_frame": "Sleva & rámeček",
			"1_plus_1_circle": "1 + 1 ZDARMA",
			"buy_one_get_one_free": "1+1 zdarma",
			"last_piece": "Poslední kus",
			"new_year_sale": "Novoroční výprodej",
			"free_gift": "dárek zdarma",
			"add_to_cart": "do košíku",
			"sale": "výprodej",
			"buy_now": "koupit teď",
			"buy": "koupit",
			"order_now": "objednat",
			"free_delivery": "doprava zdarma",
			"newie": "novinka",
			"in_stock": "skladem",
			"project_health": "Zdraví projektu",
			"find_by": "Najít",
			"fonts": "Fonty",
			"send_mailgun_notifications": "Posílat systémové notifikace a tipy na mail",
			"force_remove_alpha": "Odstranění alpha kanálu z obrázku před posíláním na odstranění pozadí",
			"auto_template_priority": "Automaticky uspořádat pořadí šablon",
			"no_watermark_mask_defined": "Nejprve je potřeba označit umístění vodoznaku.",
			"brush": "Štětec",
			"eraser": "Guma",
			"main_image_opt": "Hlavní obrázek",
			"layout_opt": "Koláž",
			"skip_refresh_images": "Stahovat obrázky jen při změně jejich URL",
			"skip_refresh_images_hint": "Nevytěžuje tolik server s uloženými obrázky. Pozn: pokud url obrázku zůstane stejná, pouze se změní obsah, nelze tuto změnu zjistit automaticky.",
			"or": "nebo",
			"preferred_product_id": "Preferované ID",
			"random_product_id": "Načtený produkt",
			"other": "jiný",
			"group_all_templates": "Všechny šablony",
			"group_discounts_and_sales": "Akce a slevy",
			"group_black_friday": "Black Friday",
			"group_cyber_monday": "Cyber Monday",
			"group_gift": "Dárek zdarma",
			"group_free_delivery": "Doprava zdarma",
			"group_new_year_sale": "Novoroční výprodej",
			"group_viva_magenta": "Viva Magenta",
			"group_midjourney": "Midjourney",
			"group_generic": "Univerzální šablony",
			"group_new": "Novinky",
			"group_seasonal": "Sezónní kampaně",
			"group_availability": "Skladová dostupnost",
			"group_christmas": "Vánoční kampaň",
			"group_effects": "Efekty",
			"group_background": "Pozadí",
			"group_warranty": "Záruka",
			"group_valentine": "Valentýn",
			"group_size_variant": "Velikostní varianty",
			"custom": "Vlastní",
			"no_watermark_groups_yet": "Zatím nemáte žádné skupiny vodoznaků.",
			"no_watermark_groups_published_yet": "Zatím nemáte žádné odeslané skupiny vodoznaků.",
			"start_here": "Začněte zde",
			"select_images_to_watermark_groups": "Vyberte několik obrázků se stejným vodoznakem.",
			"watermark_groups_info_0": "Pro každý typ vodoznaku je třeba označit několik obrázků stejným vodoznakem. Tyto obrázky budou použity k trénování modelu.",
			"watermark_groups_info_1": "todo",
			"images_from_mergado": "Obrázky z MERGADA",
			"images_from_fie": "Produktové obrázky z pravidel",
			"images_from_upload": "Nahrané obrázky",
			"select_images_with_same_watermark": "Vyberte obrázky",
			"create_watermark_mask": "Zamalujte štětcem vodoznak",
			"create_watermark_group": "Vytvořit",
			"create_new_watermark_group": "Vytvořit novou skupinu obrázků",
			"append_to_watermark_group": "Připojit",
			"to_wm_group": "do skupiny",
			"add": "Přidat",
			"add_image": "Přidat obrázek",
			"no_watermark_mask": "Označtě prosím vodoznak",
			"publish_to_trainer": "Odeslat ke trénování",
			"images_in_group": "Obrázky ve skupině",
			"rename": "Přejmenovat",
			"group_exists": "Skupina s tímto názvem už existuje",
			"cannot_be_empty": "Nesmí být prázdné",
			"sent": "Odesláno",
			"confirm_remove_group_image": "Smazat obrázek ze skupiny vodoznaků?",
			"confirm_remove_group": "Smazat skupinu vodoznaků",
			"empty_watermark_group": "Skupina vodoznaků neobsahuje žádné obrázky. Začněte nahráním obrázků do skupiny.",
			"unpublished_group": "Skupina nebyla odeslána k trénování modelu",
			"watermark_group_hash_diff": "Skupina byla změněna. Je potřeba odeslat znovu pro trénování.",
			"watermark_group_some_images_without_mask": "Některé produkty v této skupině nemají označený vodoznak.",
			"spacing": "Mezery",
			"line_spacing": "Řádkování",
			"letter_spacing": "Rozpal",
			"lines_and_letters_spacing": "Mezery mezi písmeny",
			"publish_to_detector": "Odeslat do detektoru vodoznaků",
			"published": "Odesláno",
			"no_gradients_yet": "Zatím nemáte vytvořený žádný gradient",
			"results": "Výsledky",
			"no_results_yet": "Zatím žádné výsledky",
			"template_name_max_100": "max délka názvu je 100 znaků",
			"clockwise": "Po směru hodinových ručiček",
			"counter_clockwise": "Proti směru hodinových ručiček",
			"no_color": "žádná",
			"text_stroke": "Obrys textu",
			"text_stroke_underlayer": "Obrys jako podklad (nemění se tloušťka textu)",
			"text_stroke_inside": "Obrys kolem textu na úkor tloušťky textu",
			"text_padding": "Odsazení textu",
			"select_format_to_see_templates": "Pro prohlížení grafických šablon nejprve zvolte výstupní formát obrázků.",
			"warn_inactive_fie_queries": "Tyto předdefinované výběry nejsou aktivní",
			"warn_rules_not_applied_yet": "Tyto výběry ještě nejsou v seznamu, protože neproběhla pravidla",
			"random_colors": "Náhodné barvy",
			"random_gradients": "Náhodné gradienty",
			"dominant_color": "Barva z produktu",
			"warn_transparent_background": "Pokud chcete u obrázků na výstupu <b>průhledné pozadí</b>, vyberte v Nastaveních jako výstupní formát .png.",
			"import_palette": "Importovat paletu",
			"delete_palette": "Smazat paletu",
			"add_color": "Přidat barvu",
			"group_easter_campaign": "Velikonoční kampaň",
			"happy_easter": "Veselé Velikonoce",
			"easter_discounts": "VELIKONOČNÍ SLEVY",
			"easters": "VELIKONOČNÍ",
			"spring": "JARNÍ",
			"spring_sales": "Jarní výprodej",
			"spring_discounts": "Jarní slevy",
			"discounts": "SLEVY",
			"discount_30": "SLEVA 30%",
			"discounts_30": "SLEVY -30%",
			"up_to_20": "až 20%",
			"right": "PRÁVĚ",
			"now": "TEĎ",
			"click_here": "KLIKNI ZDE",
			"buy_here": "NAKUPUJ ZDE",
			"watermark_mark_images": "Vyberte a označte 10 až 15 obrázků, které obsahují stejný vodoznak.",
			"watermark_max_images": "Max 15 obrázků",
			"watermark_min_images": "Min 10 obrázků",
			"marked_watermarks": "označených vodoznaků",
			"not_published_yet": "zatím neodesláno",
			"text_orientation": "Orientace textu",
			"horizontal_orientation": "vodorovně",
			"vertical_orientation": "svisle",
			"clip_mask": "Maska ořezu",
			"add_clip_mask": "Přidat masku ořezu",
			"invert_clip_mask": "Invertovat masku ořezu",
			"finish": "Dokončit",
			"watermark_is_marked": "Vodoznak je označen",
			"already_used_image": "Obrázek byl již použit",
			"check_elements_title": "Ověření dostupnosti ručně zadaných elementů",
			"some_elements_not_available": "Zdá se, že některé z ručně zadaných elementů nejsou dostupné. Navrhované změny:",
			"apply_all_suggested_changes": "Aplikovat všechny navrhované změny",
			"apply_only_selected_changes": "Aplikovat vybrané změny",
			"template_layer": "Vrstva v šabloně",
			"e_img_url": "Element s adresou obrázku",
			"e_img_url_input": "Vstupní element s adresou obrázku",
			"e_alt_img_url": "Element s adresou alternativního obrázku",
			"e_alt_img_url_input": "Vstupní element s adresou alternativního obrázku",
			"e_item_id": "Element s ITEM ID",
			"e_name": "Element s názvem produktu",
			"e_productno": "Element s číslem produktu",
			"e_price_vat": "Element s cenou",
			"e_url": "Element s adresou do obchodu",
			"e_ean": "EAN element",
			"template": "šablona",
			"layer": "vrstva",
			"audit_promo_templates": "Ukázkové šablony v auditu",
			"save_and_rerender_promo": "Uložit a vyrenderovat promo u existujích projektů",
			"reload_saved": "Znovu načíst uložené",
			"back_to_predefined": "Zpět předdefinované",
			"reset_filters": "Zrušit filtry",
			"has_complex_background": "Komplexní pozadí",
			"complex_background_threshold": "práh pro komplexní pozadí",
			"empty_background_probability": "pravděpodobnost prázdného pozadí",
			"object_bounding_box_to_image_ratio": "poměr rámečku ohraničení objektu ku obrázku",
			"set_template_size": "Nastavit rozměry šablony (doporučeno)",
			"keep_original_image_size": "Ponechat původní rozměry obrázku",
			"no_template_size_is_selected_title": "Chybí rozměry šablony",
			"no_template_size_is_selected": "Nemáte vybrané rozměry šablony. Pokud máte v šabloně další vrstvy, mohou být mimo viditelnou oblast.",
			"gradient_stop_points": "koncové barvy gradientu",
			"is_autocrop": "Autocrop",
			"new_alternative_template": "Nová šablona alternativních obrázků",
			"alternative_template": "Šablona alternativních obrázků",
			"alternative_templates": "Šablony alternativních obrázků",
			"main_templates": "Šablony hlavních obrázků",
			"image_offset": "Posun obrázku vůči vymezenému tvaru",
			"collage_image_shape": "Tvar",
			"rect": "Obdélník",
			"ellipse": "Elipsa",
			"selected": "Vybrané",
			"import": "Import",
			"no_templates_found": "Nenalezeny žádné šablony",
			"auto_priority": "Automaticky uspořádat",
			"manual_priority": "Uspořádat ručně",
			"right_now": "PRÁVĚ TEĎ",
			"limited_offer": "OMEZENÁ NABÍDKA",
			"sale2": "AKCE",
			"sales_up_to_50": "SLEVY AŽ 50%",
			"sale_up_to_50": "SLEVA AŽ 50%",
			"sales_up_to": "SLEVY AŽ",
			"this_week": "TENTO TÝDEN",
			"shop_here": "nakupuj zde",
			"discounts2": "SLEVY",
			"textInsideShape": "Text uvnitř tvaru",
			"element_not_selected": "nebyl vybrán element",
			"invalid_color": "neplatná barva",
			"invalid_email": "neplatný email",
			"letter_case": "Velikost písmen",
			"keep": "beze změn",
			"to_upper_case": "na velká písmena",
			"to_lower_case": "na malá písmena",
			"first_letter_to_upper_case": "první písmeno velké",
			"first_letter_to_lower_case": "první písmeno malé",
			"first_word_letter_to_upper_case": "první písmeno ve slově velké",
			"has_person": "Postava v obrázku",
			"person_detected": "postava detekována",
			"person_not_detected": "postava nedetekována",
			"columns": "Sloupce",
			"is_keep_size": "Zachovat původní formát",
			"is_keep_size_info": "Máte vybráno ponechat původní rozměry. Nelze vkládat vrstvy, pouze efekty.",
			"contact_email": "Kontaktní email",
			"element_short_item_id": "ITEM_ID",
			"element_short_url": "URL",
			"element_short_cpc": "CPC",
			"element_short_name": "NAME",
			"element_short_img_url": "IMG_URL",
			"element_short_img_url_input": "IMG_URL",
			"element_short_alt_img_url": "IMG_ALTERNATIVE",
			"element_short_alt_img_url_input": "IMG_ALTERNATIVE",
			"element_short_price_vat": "PRICE_VAT",
			"element_short_delivery_date": "DELIVERY_DATE",
			"element_short_manufacturer": "MANUFACTURER",
			"element_short_categorytext": "CATEGORY",
			"element_short_ean": "EAN",
			"steps_first_perex": "<h4>Vítejte v rozšíření Feed Image Editor</h4><p class='perex'>Pomůžeme vám rychle a jednoduše upravovat produktové obrázky pro váš e-shop. Aby vše fungovalo správně, společně nastavíme několik základních kroků.</p>",
			"steps_last_perex": "Teď se můžete pustit do zdokonalování svých produktových obrázků. Vyberte si, s jakými úpravami chcete začít v původní šabloně.",
			"steps_first_header": "Zkontrolujte elementy ve vašem Mergado feedu",
			"steps_first_subheader": "Než začnete tvořit první šablonu nebo kampaň, ujistěte se, že jsme správně vybrali klíčové elementy z vašeho produktového feedu. Slouží k tomu, aby se do obrázků doplňovaly správné informace jako například cena, název, značka nebo dostupnost.",
			"steps_need_inspiration_perex": "Najdete ji v editovatelných šablonách, které jsme pro vás připravili.",
			"steps_need_inspiration": "Potřebujete inspiraci?",
			"first_steps_title": "Průvodce prvním nastavením",
			"steps_third": "Zůstaňme v kontaktu",
			"steps_third_subscribe": "Přihlašuji se rovněž k odběru newsletteru",
			"create_first_template": "Vytvořit první šablonu",
			"steps_create_blank": "Přidání grafických prvků a CTA",
			"steps_create_resize": "Změna velikosti na konkrétní formát",
			"steps_create_upscale": "Vylepšení kvality",
			"steps_create_bg_removal": "Odstranit pozadí",
			"steps_create_watermarks": "Odstranit vodoznak",
			"steps_create_header": "Hotovo! Můžete začít tvořit",
			"steps_create_perex": "Všechno je připraveno. Nyní můžete začít upravovat své produktové obrázky a vytvářet první šablony.",
			"steps_who_are_you_title": "Abychom vám mohli doporučit ty správné funkce a nastavení, řekněte nám, kdo jste.",
			"steps_who_are_you_subtitle": "Díky tomu vám nastavíme služby přesně na míru.",
			"steps_categorization_title": "Jaký typ e-shopu provozujete?",
			"steps_categorization": "Vyberte kategorii, která nejlépe odpovídá vašemu sortimentu. Díky vaší odpovědi vám dodáme lepší služby přesně na míru.",
			"steps_third_email": "Vaše e-mailová adresa",
			"steps_third_sublabel": "Budeme vám posílat systémová upozornění, když nastane cokoli důležitého.",
			"steps_second": "Výstupní nastavení",
			"output_image_format_sublabel": "Vyberte výstupní formát obrázků.",
			"output_image_compression_sublabel": "Nastavení úrovně kvality komprese.",
			"auto_compression_to_size_sublabel": "Automatická komprese do velikosti",
			"steps_third_email_sublabel": "Budeme vám posílat upozornění, když nastane cokoli důležitého.",
			"visual_similarity": "Vizuální podobnost",
			"ai_params": "Doplnění parametrů do produktů",
			"ai_params_generate": "Vygenerovat parametry z obrázků do feedu",
			"ai_params_is_running_on_background": "Na pozadí probíhá AI analýza obrázků a generování parametrů",
			"similar_images": "podobné obrázky",
			"find_similar_images": "Najít podobné obrázky",
			"searching_in_progress": "Probíhá vyhledávání",
			"create_list_and_publish_to_visual_similarity": "Exportovat seznam obrázků a najít podobné",
			"visual_similarity_last_update_at": "Funkce vizuální podobnosti je momentálně vypnutá. Výsledky jsou aktuální k ",
			"image_cannot_be_downloaded": "Obrázek nelze stáhnout",
			"product_has_no_image": "Produkt nemá obrázek",
			"missing_image_element": "Chybí obrázkový element",
			"visual_similarity_enabled": "Najít podobné obrázky",
			"visual_similarity_n": "Počet podobných obrázků",
			"visual_similarity_threshold": "Index podobnosti",
			"visual_similarity_search_products_in": "Hledat podobné v šablonách",
			"feature_enabled": "Funkce je zapnuta",
			"feature_disabled": "Funkce je vypnuta",
			"upload_images": "Nahrát obrázky",
			"download_images": "Stáhnout obrázky",
			"download_image": "Stáhnout obrázek",
			"upload_image": "Nahrát obrázek",
			"uploaded_images": "Nahrané obrázky",
			"external_image": "Grafické prvky",
			"blog_link": "https://www.feed-image-editor.cz/blog",
			"please_select_templates": "Vyberte šablony, ve kterých chcete hledat podobné produkty",
			"loading_results": "Načítám výsledky",
			"exporting": "Exportuji produkty",
			"task_queued": "Task zařazen do fronty",
			"waiting_before_publish": "Čekám před odesláním tasku",
			"popup_box_header": "Důležité oznámení. Měníme cenu za Feed Image Editor",
			"popup_box_body": "<p>Dobrý den,<br/><br/>od <b>1. 9. 2024</b> upravujeme cenu za aplikaci Feed Image Editor. Výše měsíčního poplatku bez DPH bude 1986 Kč (79 €). Máme pro vás však výhodnou nabídku. Pokud jste již naším klientem, máte měsíční fakturační období a do 31. 7. 2024 <b>přejdete na roční, budete mít celý rok aplikaci za 1028,8 Kč bez DPH (38,4 €) na měsíc</b>. Nabídka platí také pro nové klienty, kteří si aplikaci na rok předplatí do 31. 7. 2024.</p><p>⇨ podrobně popsané scénáře přechodu na nový ceník najdete na <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127288531702777107\")>tomto odkazu</span><p/><p>Roční fakturace vám navíc přinese 20% slevu na Mergado a všechny další aplikace z Mergado Store. Čas na to máte do 31. 7. 2024 (včetně).<p/><p>Cena je uvedena za jeden projekt.</p>",
			"understand": "Rozumím",
			"rerender": "Přegenerovat",
			"redownload": "Znovu stáhnout",
			"to_be_processed": "Zbývá spracovat",
			"similarity_less_than_n": "K danému produktu se u zvolené hodnoty indexu podobnosti nepovedlo dohledat zvolený počet podobných obrázků. Zvažte snížení hodnoty indexu podobnosti.",
			"similarity_n_limit_info": "Nastavte počet podobných obrázků, který se má k danému produktu vyhledat. K některým produktům se při dané hodnotě indexu podobnosti nemusí nutně tento počet vyhledat. V takovém případě zvažte snížení hodnoty indexu podobnosti.",
			"similarity_threshold_info": "Index podobnosti určuje míru, jak moc podobné obrázky se mají k produktu vyhledat. Čím vyšší hodnota, tím podobnější obrázky. Hodnota 1 vyhledá naprosto stejné obrázky.",
			"fill_similarity_title": "Zapisování výsledků do výstupního feedu",
			"fill_similarity_ids_element": "ID vizuálně podobných produktů",
			"fill_similarity_image_urls_element": "URL adresy vizuálně podobných obrázků",
			"no_items_filtered": "Nenalezli jsme žádný výběr",
			"no_match_with_element_regexp": "Element nevyhovuje filtru elementů pro aplikaci pravidel (element_regex)",
			"advanced_settings": "Pokročilá nastavení",
			"mergado_max_payload_size": "Maximální počet znaků odeslaných v jednom requestu. Maximální možná hodnota je 15 000 000 znaků.",
			"mergado_element_regex": "Regularní výraz podle kterého budou filtrovány elementy projektu",
			"mergado_xml_equivalent": "Mergado XML elementy, jejichž ekvivalent pro daný formát bude odeslán z Mergada.",
			"suggested_elements_to_be_excluded": "Navrhované elementy, které můžete vynechat při aplikaci pravidel",
			"alt_levels": "Úrovně obrázků alternativní šablony",
			"levels": "Úrovně aplikování",
			"assigned_templates": "Přiřazené hlavní šablony",
			"no_assigned_templates": "Žádné přiřazené šablony",
			"necessary": "Nezbytné",
			"exclude_some": "Vynechat vybrané",
			"regexp": "Regulární výraz",
			"mergado_apply_elements": "Které elementy se mají do FIE posílat při aplikaci pravidel",
			"necessary_elements": "Elementy nezbytné pro bezproblémový chod FIE",
			"selected_mergado_equivalent": "Vybrané ekvivalenty Mergado elementů",
			"categories": "Kategorie",
			"fashion": "Móda",
			"beauty": "Krása",
			"health": "Zdraví",
			"pets": "Domácí zvířata",
			"electronics": "Elektronika",
			"home_and_garden": "Domov a zahrada",
			"kids": "Děti",
			"sports": "Sporty",
			"books": "Knihy",
			"cars": "Auta",
			"services_and_experiences": "Služby a zkušenosti",
			"other_category": "Jiné",
			"back_to_original": "Vrátit pozadí",
			"paint_transparent": "Odstranit pozadí",
			"waiting_for_product_to_be_loaded": "Čeká se na načtení produktu",
			"should_rerender": "Označené k přerenderovaní",
			"should_redownload": "Označené ke znovustažení",
			"has_alt_images": "Má alternativní obrázky",
			"anim-gif": "Anim GIF",
			"auto-wmremove": "Odstranění vodoznaků",
			"format_preset": "Předchystaný",
			"format_original": "Původní",
			"format_custom": "Vlastní",
			"turned_off": "vypnuto",
			"mode": "režim",
			"inpainting_create_mask": "Vyznačte oblasti pro inpainting.",
			"inpainting_how_to_deal_with_diff_size": "Jak přizpůsobit různé velikosti masky a obrázku",
			"position_relative_to": "Pozice relativní vůči",
			"scale_mask_to_image_size": "Naškálovat masku na velikost obrázku",
			"scale_to_size": "Přizpůsobit velikost",
			"object_position": "Poloha objektu",
			"complex_background": "Komplexní pozadí",
			"edit_element_content": "Upravit obsah elementu",
			"prefix": "text před",
			"suffix": "text za",
			"decimals": "počet míst",
			"separator": "oddělovač",
			"replace": "nahradit",
			"find_as_regexp": "najít jako regulární výraz",
			"symbol_table": "Speciální symboly měn",
			"find_and_replace": "Najít a nahradit",
			"add_text": "Vložit text",
			"decimal_places": "Desetinná místa",
			"thousands_separation": "Oddělit tisíce",
			"short_url_with_extension": "Kratší url s příponou souboru",
			"short_url_with_extension_info": "Kratší forma výstupní url adresy zahrnující příponu podle výstupního formátu obrázku. Některé srovnávače vyžadují příponu obrázku v adrese.",
			"gradient_is_used_by_template": "Tento gradient je používán šablonou a nelze jej tedy smazat.",
			"no_search_image_results": "Nebyly nalezeny žádné obrázky odpovídající hledanému výrazu.",
			"import_from_project": "Import z projektu",
			"choose_project": "Zvolte projekt",
			"no_other_projects_of_user": "Žádné projekty ze kterých lze importovat.",
			"loading_queries": "Načítám výběry z Mergada",
			"loading_template": "Načítám šablonu",
			"text_mode": "Textový režim",
			"total_icons": "Počet ikon",
			"try_icons": "Vyzkoušet ikony",
			"icon_color": "Barva ikon",
			"did_not_found_stickers": "Nenašli jste vhodné samolepky?",
			"ai_elements_to_feed": "Obohacení feedu pomocí AI",
			"custom_image_author": "Autor",
			"custom_image_license": "Licence",
			"custom_image_source_url": "Zdroj",
			"custom_image_edit_source_info": "Upravit autora, licenci a zdroj",
			"custom_image_no_source_info": "Autor a licence neuvedeny",
			"mcp": "MCP",
			"toggle_auto_grow": "Automaticky zvětšovat vrstvu podle textu",
            }
        }
    